// PDFResumoCategorias.jsx
import React, { useMemo, useState, useEffect } from "react";
import { pdf, PDFViewer } from "@react-pdf/renderer";
import JSZip from "jszip";
import { saveAs } from "file-saver";

import { useLoader } from "../../contexts/LoaderContext";
import styles from "./pdfgenerator.module.css";

import PDFDocument from "./PDFDocument";
import PDFDocumentEntryOnly from "./PDFDocumentEntryOnly";

/* =========================================================
   Debug
========================================================= */
const DEBUG = true;

/* =========================================================
   Pré-visualização inline
========================================================= */
const overlayStyle = { position:"fixed", inset:0, backgroundColor:"rgba(0,0,0,0.55)", zIndex:9999, display:"flex", alignItems:"center", justifyContent:"center" };
const modalStyle   = { backgroundColor:"#fff", width:"92vw", height:"90vh", borderRadius:10, display:"flex", flexDirection:"column", overflow:"hidden", boxShadow:"0 10px 35px rgba(0,0,0,0.25)" };
const modalHeader  = { padding:"8px 12px", display:"flex", justifyContent:"space-between", alignItems:"center", borderBottom:"1px solid #eee" };
const closeBtn     = { border:0, outline:0, background:"#e91d75", color:"#fff", padding:"6px 10px", borderRadius:6, cursor:"pointer" };
function InlinePreview({ title, doc, onClose }) {
  if (!doc) return null;
  return (
    <div style={overlayStyle} role="dialog" aria-modal="true">
      <div style={modalStyle}>
        <div style={modalHeader}>
          <strong>{title || "Pré-visualização"}</strong>
          <button style={closeBtn} onClick={onClose}>Fechar</button>
        </div>
        <PDFViewer width="100%" height="100%">{doc}</PDFViewer>
      </div>
    </div>
  );
}

/* =========================================================
   Mapeamento PARTICIPANTE (exato)
========================================================= */
const perguntaParaCategoria = {
  "Em uma escala de 1 a 10, sinto que posso decidir o que fazer nas minhas tarefas do dia a dia.": { categoria: "Processo", subcategoria: "Autonomia" },
  "Em uma escala de 1 a 10, tenho liberdade para organizar meus horários e minha agenda como eu prefiro.": { categoria: "Processo", subcategoria: "Autonomia" },
  "Em uma escala de 1 a 10, tenho a liberdade de escolher com quem vou trabalhar e como dividir as tarefas.": { categoria: "Processo", subcategoria: "Autonomia" },
  "Em uma escala de 1 a 10, sinto que posso escolher como realizar meu trabalho da melhor forma possível.": { categoria: "Processo", subcategoria: "Autonomia" },
  "Em uma escala de 1 a 10, consigo tomar iniciativa para alcançar minhas metas, sem depender de instruções o tempo todo.": { categoria: "Perfil", subcategoria: "NA" },
  "Em uma escala de 1 a 10, consigo priorizar o que é mais importante para atingir meus objetivos.": { categoria: "Produtividade", subcategoria: "NA" },
  "Em uma escala de 1 a 10, sinto que ajudo minha equipe a se desenvolver, para que todos possam trabalhar com mais independência.": { categoria: "Pessoas", subcategoria: "NA" },
  "Em uma escala de 1 a 10, tenho habilidade para lidar com os erros e extrair lições para uma evolução contínua.": { categoria: "Perfil", subcategoria: "NA" },
  "Em uma escala de 1 a 10, meu gestor me orienta adequadamente, permitindo-me tomar decisões por conta própria.": { categoria: "Liderança", subcategoria: "NA" },
  "Em uma escala de 1 a 10, meu líder confia em sua própria autonomia e não precisa depender de outro gestor o tempo todo.": { categoria: "Liderança", subcategoria: "NA" },
  "Em uma escala de 1 a 10, eu me conheço bem, entendo meus sentimentos e reconheço minhas fraquezas.": { categoria: "Perfil", subcategoria: "NA" },
  "Em uma escala de 1 a 10, minha rotina é equilibrada e eu acordo animado(a) para o dia.": { categoria: "Produtividade", subcategoria: "NA" },
  "Em uma escala de 1 a 10, reconheço minhas qualidades e valores e sei como eles me ajudam a alcançar melhores resultados.": { categoria: "Perfil", subcategoria: "NA" },
  "Em uma escala de 1 a 10, me sinto otimista com o futuro e orgulhoso(a) do que já conquistei.": { categoria: "Propósito", subcategoria: "NA" },
  "Em uma escala de 1 a 10, consigo analisar meus erros sem me criticar demais, aprendendo com eles.": { categoria: "Perfil", subcategoria: "NA" },
  "Em uma escala de 1 a 10, sinto que meu trabalho está conectado com o meu propósito e isso me dá orgulho.": { categoria: "Propósito", subcategoria: "NA" },
  "Em uma escala de 1 a 10, sou capaz de definir meus objetivos e direcionar minhas emoções para alcançá-los.": { categoria: "Perfil", subcategoria: "NA" },
  "Em uma escala de 1 a 10, reconheço o que os outros estão sentindo e use a empatia para me conectar melhor com eles.": { categoria: "Pessoas", subcategoria: "NA" },
  "Em uma escala de 1 a 10, me relaciono bem com as pessoas, me comunico de forma clara e presto atenção no que os outros precisam.": { categoria: "Pessoas", subcategoria: "Comunicação" },
  "Em uma escala de 1 a 10, sou capaz de liderar e coordenar um grupo para atingir os resultados esperados.": { categoria: "Pessoas", subcategoria: "NA" },
  "Em uma escala de 1 a 10, recebo feedbacks úteis do meu gestor com frequência e de forma organizada.": { categoria: "Liderança", subcategoria: "NA" },
  "Em uma escala de 1 a 10, sou aberto(a) a feedbacks e sempre me comprometo com os planos de ação combinados.": { categoria: "Perfil", subcategoria: "Comunicação" },
  "Em uma escala de 1 a 10, estou sempre disponível para ouvir e contribuir com uma comunicação clara e eficiente dentro do time.": { categoria: "Pessoas", subcategoria: "Comunicação" },
  "Em uma escala de 1 a 10, as informações importantes são compartilhadas de forma clara e rápida na empresa em que eu trabalho.": { categoria: "Processo", subcategoria: "Comunicação" },
  "Em uma escala de 1 a 10, me sinto ouvido(a) pelo meu gestor.": { categoria: "Liderança", subcategoria: "NA" },
  "Em uma escala de 1 a 10, sou feliz com o trabalho que faço na empresa.": { categoria: "Propósito", subcategoria: "NA" },
  "Em uma escala de 1 a 10, me sinto feliz por trabalhar na empresa em que eu trabalho.": { categoria: "Propósito", subcategoria: "NA" },
  "Em uma escala de 1 a 10, reconheço as habilidades de cada pessoa do meu time e sei como elas ajudam nos resultados.": { categoria: "Pessoas", subcategoria: "NA" },
  "Em uma escala de 1 a 10, os processos da empresa em que eu trabalho incentiva a independência dos líderes e equipes.": { categoria: "Processo", subcategoria: "Autonomia" },
  "Em uma escala de 1 a 10, confio na visão e na postura do CEO da empresa em que eu trabalho.": { categoria: "Liderança", subcategoria: "NA" },
};

/* =========================================================
   Normalização e resolutores
========================================================= */
const normalize = (s="") =>
  String(s || "")
    .normalize("NFD").replace(/[\u0300-\u036f]/g, "")
    .toLowerCase()
    .replace(/\s+/g, " ")
    .trim();

const resolverParticipante = (pergunta) => perguntaParaCategoria[pergunta] || null;

/** Resolver do MENTOR — por contexto, com fallbacks defensivos */
const resolverMentor = (pergunta) => {
  const p = normalize(pergunta);

  // --- Subcategoria Autonomia (sempre em Processo)
  if (/(autonomi|independenc|autonomo|decidir|liberdade)/.test(p)) {
    return { categoria: "Processo", subcategoria: "Autonomia" };
  }

  // --- Comunicação (pode cair em Pessoas/Processo/Perfil)
  const hasCom = /(comunic|escut|ouvir|clara|clareza|assertiv|transparen|alinhamento)/.test(p);
  const ctxPessoas =
    /(time|equipe|coleg|pessoa|stakeholder|cliente|grupo|reuniao|colab|parceria)/.test(p);
  const ctxProcesso =
    /(empresa|process|fluxo|setor|entre areas|intersetoria|informac|documenta|procediment|interna)/.test(p);
  const ctxPerfil =
    /(feedback|abert[oa]? a feedback|abert[oa]|compromet|plano[s]? de acao|planos de acao)/.test(p);

  if (hasCom) {
    if (ctxProcesso) return { categoria: "Processo", subcategoria: "Comunicação" };
    if (ctxPerfil)   return { categoria: "Perfil",  subcategoria: "Comunicação" };
    if (ctxPessoas)  return { categoria: "Pessoas", subcategoria: "Comunicação" };
    // fallback: se é comunicação sem contexto explícito, assume Pessoas
    return { categoria: "Pessoas", subcategoria: "Comunicação" };
  }

  // --- Liderança geral
  if (/(gestor|lider|lideranca|ceo)/.test(p)) {
    return { categoria: "Liderança", subcategoria: "NA" };
  }

  // --- Categorias gerais (sem sub)
  if (/(iniciativa|proprios erros|autoconhe|conhece .*sentimentos|qualidades e valores|otimista|definir .*objetivos)/.test(p))
    return { categoria: "Perfil", subcategoria: "NA" };

  if (/(priorizar|rotina equilibrada|gestao do tempo|agenda)/.test(p))
    return { categoria: "Produtividade", subcategoria: "NA" };

  if (/(relaciono bem|empatia|habilidades de cada pessoa|liderar e coordenar um grupo)/.test(p))
    return { categoria: "Pessoas", subcategoria: "NA" };

  if (/(proposito|feliz com o trabalho|feliz por trabalhar)/.test(p))
    return { categoria: "Propósito", subcategoria: "NA" };

  if (/(processos|processo)/.test(p))
    return { categoria: "Processo", subcategoria: "NA" };

  return null;
};

/* =========================================================
   Cálculos
========================================================= */
const toNum = (v) => {
  const n = Number(v);
  return Number.isFinite(n) ? n : NaN;
};

const calcularMedias = (dados, resolveInfo = resolverParticipante, debugLabel = "") => {
  if (!Array.isArray(dados) || dados.length === 0) {
    if (DEBUG) console.warn("Dados inválidos para cálculo de médias.", debugLabel);
    return { resultados: {}, subResultados: {} };
  }

  const categorias = ["Perfil", "Pessoas", "Processo", "Produtividade", "Propósito"];
  const subcategorias = ["Autonomia", "Comunicação"];

  const resultados = {};
  const subResultados = {};

  let totalPerguntas = 0;
  let mapeadas = 0;

  categorias.forEach((categoria) => {
    const valores = [];

    dados.forEach((resposta) => {
      if (typeof resposta !== "object") return;
      Object.entries(resposta).forEach(([pergunta, valor]) => {
        totalPerguntas++;
        const info = resolveInfo(pergunta);
        if (info) mapeadas++;
        const n = toNum(valor);
        if (info && info.categoria === categoria && Number.isFinite(n)) {
          valores.push(n);
        }
      });
    });

    if (valores.length) {
      resultados[categoria] = (valores.reduce((a, v) => a + v, 0) / valores.length).toFixed(2);
    }

    subcategorias.forEach((sub) => {
      const subValores = [];
      dados.forEach((resposta) => {
        if (typeof resposta !== "object") return;
        Object.entries(resposta).forEach(([pergunta, valor]) => {
          const info = resolveInfo(pergunta);
          const n = toNum(valor);
          if (info && info.categoria === categoria && info.subcategoria === sub && Number.isFinite(n)) {
            subValores.push(n);
          }
        });
      });
      if (subValores.length) {
        subResultados[`${categoria} - ${sub}`] =
          (subValores.reduce((a, v) => a + v, 0) / subValores.length).toFixed(2);
      }
    });
  });

  if (DEBUG && debugLabel) {
    console.groupCollapsed(`[DEBUG] Cobertura — ${debugLabel}`);
    console.log("Perguntas avaliadas:", totalPerguntas);
    console.log("Perguntas mapeadas:", mapeadas);
    console.log("Cobertura (%):", totalPerguntas ? ((mapeadas / totalPerguntas) * 100).toFixed(1) : "0");
    console.log("Subchaves geradas:", Object.keys(subResultados));
    console.groupEnd();
  }

  return { resultados, subResultados };
};

const calcularMediasComLideranca = (dados, resolveInfo = resolverParticipante, debugLabel = "") => {
  if (!Array.isArray(dados) || dados.length === 0) {
    if (DEBUG) console.warn("Dados inválidos para cálculo com liderança.", debugLabel);
    return { resultados: {}, subResultados: {}, mediaLideranca: null };
  }

  const { resultados, subResultados } = calcularMedias(dados, resolveInfo, debugLabel);
  const valoresLideranca = [];

  dados.forEach((resposta) => {
    if (typeof resposta !== "object") return;
    Object.entries(resposta).forEach(([pergunta, valor]) => {
      const info = resolveInfo(pergunta);
      const n = toNum(valor);
      if (info && info.categoria === "Liderança" && Number.isFinite(n)) {
        valoresLideranca.push(n);
      }
    });
  });

  const mediaLideranca = valoresLideranca.length
    ? (valoresLideranca.reduce((a, v) => a + v, 0) / valoresLideranca.length).toFixed(2)
    : null;

  return { resultados, subResultados, mediaLideranca };
};

/* =========================================================
   EXTREMOS por categoria (prioriza SAÍDA; fallback ENTRADA)
   - Consolidado: maior/menor pela SAÍDA quando houver.
   - Entry only: avalia pela ENTRADA (pois não há saída).
   - Desempate: alfabético por categoria.
========================================================= */
const extremosPorCategoria = (entradaResumo, saidaResumo = null) => {
  const ent = entradaResumo?.resultados || {};
  const sai = saidaResumo?.resultados || {};

  const categorias = Array.from(new Set([...Object.keys(ent), ...Object.keys(sai)]));

  const pares = categorias.map((categoria) => {
    const entrada = toNum(ent[categoria]);
    const saida   = toNum(sai[categoria]);
    // Critério de comparação: preferir SAÍDA; se NaN, cair em ENTRADA
    const crit = Number.isFinite(saida) ? saida : (Number.isFinite(entrada) ? entrada : NaN);
    return { categoria, entrada, saida, crit };
  }).filter(p => Number.isFinite(p.crit));

  const alphaTiebreak = (a, b) =>
    a.categoria.localeCompare(b.categoria, "pt-BR", { sensitivity: "base" });

  const maior = pares.reduce((best, cur) => {
    if (!best) return cur;
    if (cur.crit > best.crit) return cur;
    if (cur.crit < best.crit) return best;
    return alphaTiebreak(cur, best) < 0 ? cur : best;
  }, null);

  const menor = pares.reduce((best, cur) => {
    if (!best) return cur;
    if (cur.crit < best.crit) return cur;
    if (cur.crit > best.crit) return best;
    return alphaTiebreak(cur, best) < 0 ? cur : best;
  }, null);

  if (DEBUG) {
    console.groupCollapsed("[DEBUG] extremosPorCategoria");
    console.log("Entrada.resultados:", entradaResumo?.resultados);
    console.log("Saida.resultados:", saidaResumo?.resultados);
    console.table(pares.map(p => ({
      categoria: p.categoria,
      entrada: p.entrada,
      saida: p.saida,
      criterioComparacao: p.crit,
    })));
    console.log("Escolhido MAIOR:", maior);
    console.log("Escolhido MENOR:", menor);
    console.groupEnd();
  }

  return { maior, menor };
};

/* =========================================================
   Helpers (agrupadores e utilitários)
========================================================= */
const normalizeEmail = (raw = "") =>
  String(raw || "")
    .trim()
    .toLowerCase()
    .replace(/\s+/g, " ")
    .replace(/\)\s*$/, ")")
    .replace(/\s+@/g, "@")
    .replace(/\s+$/g, "");

const isValidEmail = (s) => /^[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,}$/i.test(String(s || "").trim());
const extractEmailFromParens = (text) => {
  if (!text) return "";
  const t = normalizeEmail(text);
  const m = t.match(/\(([^)]+)\)/);
  const inner = m && m[1] ? normalizeEmail(m[1]) : "";
  const candidate = inner && isValidEmail(inner) ? inner : (t.match(/[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,}/i)?.[0] || "");
  return normalizeEmail(candidate);
};

const getNthKey = (arr, n) => (arr?.[0] ? (Object.keys(arr[0])[n] ?? null) : null);
const pick = (row, key) => (key && row ? String(row[key] ?? "").trim() : "");

const detectEmailColumn = (rows, preferredIndex = null, headerRegex = null) => {
  if (!rows?.length) return null;
  const keys = Object.keys(rows[0]);
  if (preferredIndex != null && keys[preferredIndex]) return keys[preferredIndex];
  if (headerRegex) {
    const k = keys.find((c) => headerRegex.test(String(c)));
    if (k) return k;
  }
  let bestKey = null, bestScore = -1;
  for (const k of keys) {
    let valid = 0, total = 0;
    for (let i = 0; i < Math.min(200, rows.length); i++) {
      const v = normalizeEmail(rows[i][k]);
      if (v) { total++; if (isValidEmail(v)) valid++; }
    }
    const score = total ? valid / total : 0;
    if (score > bestScore) { bestScore = score; bestKey = k; }
  }
  return bestKey;
};

const detectMentorMenteeColumn = (rows) => {
  if (!rows?.length) return null;
  const keys = Object.keys(rows[0]);
  const headerKey = keys.find((k) => /participante|mentee|avaliar|mentorado/i.test(String(k)));
  if (headerKey) return headerKey;
  let bestKey = null, bestHits = -1;
  for (let idx = 0; idx < Math.min(10, keys.length); idx++) {
    const k = keys[idx];
    let hits = 0, checked = 0;
    for (let i = 0; i < Math.min(200, rows.length); i++) {
      const v = String(rows[i][k] ?? "");
      if (!v) continue;
      checked++;
      if (/\([^)@]*@[^\)]+\)/.test(v)) hits++;
    }
    if (checked && hits > bestHits) { bestHits = hits; bestKey = k; }
  }
  return bestKey;
};

const agruparUsuarios = (dados) => {
  if (!Array.isArray(dados) || !dados.length) return {};
  const emailKey = detectEmailColumn(dados, 1, /(e-?mail|email)/i) || getNthKey(dados, 1);
  const nomeKey  = getNthKey(dados, 2);
  const sobKey   = getNthKey(dados, 3);

  const grouped = dados.reduce((acc, row) => {
    const email = normalizeEmail(pick(row, emailKey));
    if (!isValidEmail(email)) return acc;
    const nomeExib = [pick(row, nomeKey), pick(row, sobKey)].filter(Boolean).join(" ").trim();
    if (!acc[email]) acc[email] = { rows: [], nome: nomeExib || email };
    acc[email].rows.push(row);
    if (!acc[email].nome && nomeExib) acc[email].nome = nomeExib;
    return acc;
  }, {});
  if (DEBUG) {
    console.groupCollapsed("[DEBUG] AgruparUsuarios");
    console.log("emailKey:", emailKey);
    console.log("Exemplo:", Object.values(grouped)[0]);
    console.groupEnd();
  }
  return grouped;
};

const agruparMentor = (dados) => {
  if (!Array.isArray(dados) || !dados.length) return {};
  const menteeKey = detectMentorMenteeColumn(dados) || getNthKey(dados, 4);
  const grouped = dados.reduce((acc, row) => {
    const raw = pick(row, menteeKey);
    const email = extractEmailFromParens(raw);
    if (!isValidEmail(email)) return acc;
    const nomeGuess = raw.includes(" (") ? raw.split(" (")[0].trim() : "";
    if (!acc[email]) acc[email] = { rows: [], nome: nomeGuess || email };
    acc[email].rows.push(row);
    if (!acc[email].nome && nomeGuess) acc[email].nome = nomeGuess;
    return acc;
  }, {});
  if (DEBUG) {
    console.groupCollapsed("[DEBUG] AgruparMentor");
    console.log("menteeKey:", menteeKey);
    console.log("Exemplo:", Object.values(grouped)[0]);
    console.groupEnd();
  }
  return grouped;
};

const getFirstSubmissionDate = (rows) => {
  if (!Array.isArray(rows) || !rows.length) return "";
  const keys = Object.keys(rows[0]);
  const dateKey = keys.find((k) => /submission\s*date/i.test(k)) || keys.find((k) => /data/i.test(k)) || null;
  return pick(rows[0], dateKey);
};

const flattenRowsForEmails = (groupedByEmail, emailList) => {
  const rows = [];
  emailList.forEach((e) => rows.push(...(groupedByEmail?.[e]?.rows || [])));
  return rows;
};

/* =========================================================
   Casamentos
========================================================= */
const construirCasamentos = ({ entradaByEmail, saidaByEmail, mentorEntradaByEmail, mentorSaidaByEmail, consolidado }) => {
  const emailsEntrada = Object.keys(entradaByEmail || {});
  const emailsSaida   = Object.keys(saidaByEmail || {});
  const emailsMentIn  = new Set(Object.keys(mentorEntradaByEmail || {}));
  const emailsMentOut = new Set(Object.keys(mentorSaidaByEmail || {}));

  const base = emailsEntrada.filter(e => (consolidado ? emailsSaida.includes(e) : true));

  const linhas = base.map((email) => ({
    email,
    nomeEntrada: entradaByEmail[email]?.nome || "",
    nomeSaida: saidaByEmail[email]?.nome || "",
    hasMentorEntrada: emailsMentIn.has(email),
    hasMentorSaida: consolidado ? emailsMentOut.has(email) : null,
  }));

  if (DEBUG) {
    console.groupCollapsed("[DEBUG] Casamentos — visão geral");
    console.table(linhas);
    console.groupEnd();
  }

  return { participantesBase: base, linhas };
};

/* =========================================================
   Componente principal
========================================================= */
const PDFResumoCategorias = ({
  entrada = [],
  saida = [],
  mentorEntrada = [],
  mentorSaida = [],
  onFinalizado,
  PJ = false,
  programa,
  empresa,
  consolidado,
}) => {
  const { showLoader, hideLoader } = useLoader();
  const [previewDoc, setPreviewDoc] = useState(null);
  const [previewTitle, setPreviewTitle] = useState("");

  const formatarMesAno = (dataStr) => {
    const data = new Date(dataStr);
    if (isNaN(data)) return "";
    const meses = ["JAN","FEV","MAR","ABR","MAI","JUN","JUL","AGO","SET","OUT","NOV","DEZ"];
    return `${meses[data.getMonth()]}/${String(data.getFullYear()).slice(-2)}`;
  };

  const entradaByEmail       = useMemo(() => agruparUsuarios(entrada), [entrada]);
  const saidaByEmail         = useMemo(() => (consolidado ? agruparUsuarios(saida) : {}), [consolidado, saida]);
  const mentorEntradaByEmail = useMemo(() => agruparMentor(mentorEntrada), [mentorEntrada]);
  const mentorSaidaByEmail   = useMemo(() => (consolidado ? agruparMentor(mentorSaida) : {}), [consolidado, mentorSaida]);

  const casamento = useMemo(
    () => construirCasamentos({ entradaByEmail, saidaByEmail, mentorEntradaByEmail, mentorSaidaByEmail, consolidado }),
    [entradaByEmail, saidaByEmail, mentorEntradaByEmail, mentorSaidaByEmail, consolidado]
  );

  const participantesEmails = useMemo(() => casamento.participantesBase, [casamento.participantesBase]);

  useEffect(() => {
    if (!DEBUG) return;
    console.groupCollapsed("[DEBUG] Detalhes por participante");
    casamento.linhas.forEach((lin) => {
      const eRows = entradaByEmail[lin.email]?.rows || [];
      const sRows = saidaByEmail[lin.email]?.rows || [];
      const mIn   = mentorEntradaByEmail[lin.email]?.rows || [];
      const mOut  = mentorSaidaByEmail[lin.email]?.rows || [];
      console.groupCollapsed(lin.email);
      console.log("Nome (Entrada):", lin.nomeEntrada);
      console.log("Nome (Saída):", lin.nomeSaida);
      console.log("Data Entrada:", getFirstSubmissionDate(eRows));
      if (consolidado) console.log("Data Saída:", getFirstSubmissionDate(sRows));

      const ent = calcularMediasComLideranca(eRows, resolverParticipante, `P-Entrada (${lin.email})`);
      const sai = consolidado ? calcularMediasComLideranca(sRows, resolverParticipante, `P-Saída (${lin.email})`) : null;
      const menIn  = mIn.length  ? calcularMedias(mIn,  resolverMentor, `M-Entrada (${lin.email})`) : null;
      const menOut = (consolidado && mOut.length) ? calcularMedias(mOut, resolverMentor, `M-Saída (${lin.email})`) : null;

      console.log("Mentor Entrada subKeys:", menIn ? Object.keys(menIn.subResultados) : []);
      console.log("Mentor Saída   subKeys:", menOut ? Object.keys(menOut.subResultados) : []);
      console.groupEnd();
    });
    console.groupEnd();
  }, [casamento, entradaByEmail, saidaByEmail, mentorEntradaByEmail, mentorSaidaByEmail, consolidado]);

  const construirDocumentoDe = (email) => {
    const nome = entradaByEmail[email]?.nome || saidaByEmail[email]?.nome || email;

    const entradaDados = entradaByEmail[email]?.rows || [];
    const saidaDados   = consolidado ? (saidaByEmail[email]?.rows || []) : [];

    if (!entradaDados.length || (consolidado && !saidaDados.length)) return null;

    const entradaResumo = calcularMediasComLideranca(entradaDados, resolverParticipante);
    const saidaResumo   = consolidado ? calcularMediasComLideranca(saidaDados, resolverParticipante) : null;

    const mentorEntradaDados = mentorEntradaByEmail[email]?.rows || [];
    const mentorSaidaDados   = consolidado ? (mentorSaidaByEmail[email]?.rows || []) : [];

    const mentorEntradaResumo = mentorEntradaDados.length ? calcularMedias(mentorEntradaDados, resolverMentor, "Mentor-Entrada (agg)") : null;
    const mentorSaidaResumo   = (consolidado && mentorSaidaDados.length) ? calcularMedias(mentorSaidaDados, resolverMentor, "Mentor-Saída (agg)") : null;

    const dataEntrada = formatarMesAno(getFirstSubmissionDate(entradaDados));
    const dataSaida   = consolidado ? formatarMesAno(getFirstSubmissionDate(saidaDados)) : "";

    // >>> extremos calculados aqui e passados ao PDF (prioriza SAÍDA)
    const { maior, menor } = extremosPorCategoria(entradaResumo, saidaResumo);

    if (DEBUG) {
      console.groupCollapsed(`[DEBUG] Extremos escolhidos — ${email}`);
      console.log("EntradaResumo.resultados:", entradaResumo.resultados);
      console.log("SaidaResumo.resultados:", saidaResumo?.resultados);
      console.log("maiorPar:", maior);
      console.log("menorPar:", menor);
      console.groupEnd();
    }

    return consolidado ? (
      <PDFDocument
        entradaResumo={entradaResumo}
        saidaResumo={saidaResumo}
        mentorEntradaResumo={mentorEntradaResumo}
        mentorSaidaResumo={mentorSaidaResumo}
        nomeParticipante={nome}
        programa={programa}
        dataEntrada={dataEntrada}
        dataSaida={dataSaida}
        // pares prontos:
        maiorPar={maior}
        menorPar={menor}
      />
    ) : (
      <PDFDocumentEntryOnly
        entradaResumo={entradaResumo}
        mentorEntradaResumo={mentorEntradaResumo}
        nomeParticipante={nome}
        programa={programa}
        dataEntrada={dataEntrada}
        // pares (base entrada)
        maiorPar={maior}
        menorPar={menor}
      />
    );
  };

  const emailParaPreview = useMemo(() => {
    const emailsMentor = new Set([
      ...Object.keys(mentorEntradaByEmail || {}),
      ...Object.keys(mentorSaidaByEmail || {}),
    ]);
    const intersec = participantesEmails.filter((e) => emailsMentor.has(e));
    if (consolidado) {
      const completos = intersec.filter((e) => mentorEntradaByEmail[e] && mentorSaidaByEmail[e]);
      return completos[0] || intersec[0] || participantesEmails[0] || null;
    }
    return intersec[0] || participantesEmails[0] || null;
  }, [participantesEmails, mentorEntradaByEmail, mentorSaidaByEmail, consolidado]);

  const abrirPreview = () => {
    const email = emailParaPreview;
    if (!email) return alert("Não há participante elegível para pré-visualização.");
    const doc = construirDocumentoDe(email);
    if (!doc) return alert("Não foi possível montar a pré-visualização deste participante.");
    const nome = entradaByEmail[email]?.nome || email;
    setPreviewTitle(`Pré-visualização — ${nome}`);
    setPreviewDoc(doc);
  };

  const gerarPDF = async () => {
    if (participantesEmails.length === 0) return alert("Nenhum participante com dados completos foi encontrado.");
    const zip = new JSZip();
    try {
      for (let i = 0; i < participantesEmails.length; i++) {
        const email = participantesEmails[i];
        const nome = entradaByEmail[email]?.nome || saidaByEmail[email]?.nome || email;

        showLoader(`Gerando relatório ${i + 1} de ${participantesEmails.length}`);
        const doc = construirDocumentoDe(email);
        if (!doc) continue;

        const pdfBlob = await pdf(doc).toBlob();
        zip.file(`${(nome || email).replace(/[\\/:*?"<>|]/g, "_")}.pdf`, pdfBlob);
      }

      // Institucional (PJ)
      showLoader("Gerando relatório institucional");
      const entradaReconhecida = flattenRowsForEmails(entradaByEmail, participantesEmails);
      const saidaReconhecida   = consolidado ? flattenRowsForEmails(saidaByEmail, participantesEmails) : [];
      const entradaResumoPJ    = calcularMediasComLideranca(entradaReconhecida, resolverParticipante);
      const saidaResumoPJ      = consolidado ? calcularMediasComLideranca(saidaReconhecida, resolverParticipante) : null;

      // extremos também para o institucional (prioriza saída)
      const { maior: maiorPJ, menor: menorPJ } = extremosPorCategoria(entradaResumoPJ, saidaResumoPJ);

      const instDoc = consolidado ? (
        <PDFDocument
          entradaResumo={entradaResumoPJ}
          saidaResumo={saidaResumoPJ}
          mentorEntradaResumo={null}
          mentorSaidaResumo={null}
          nomeParticipante={PJ ? (empresa || "Institucional") : "Institucional"}
          programa={programa}
          dataEntrada={formatarMesAno(getFirstSubmissionDate(entradaReconhecida))}
          dataSaida={formatarMesAno(getFirstSubmissionDate(saidaReconhecida))}
          maiorPar={maiorPJ}
          menorPar={menorPJ}
        />
      ) : (
        <PDFDocumentEntryOnly
          entradaResumo={entradaResumoPJ}
          mentorEntradaResumo={null}
          nomeParticipante={PJ ? (empresa || "Institucional") : "Institucional"}
          programa={programa}
          dataEntrada={formatarMesAno(getFirstSubmissionDate(entradaReconhecida))}
          maiorPar={maiorPJ}
          menorPar={menorPJ}
        />
      );

      const pdfBlobPJ = await pdf(instDoc).toBlob();
      zip.file("Relatorio_Institucional.pdf", pdfBlobPJ);

      showLoader("Compactando arquivos");
      const zipBlob = await zip.generateAsync({ type: "blob" });
      saveAs(zipBlob, "relatorios.zip");
    } catch (error) {
      console.error("Erro ao gerar os relatórios:", error);
      alert("Erro ao gerar os relatórios. Verifique os dados e tente novamente.");
    } finally {
      hideLoader();
      onFinalizado && onFinalizado();
    }
  };

  return (
    <div className={styles.pdfGeneratorContainer}>
      <h2 className={styles.sectionTitle}>Gerar Resumo por Categoria</h2>

      <div className={styles.buttonsRow}>
        {DEBUG && (
          <button
            onClick={abrirPreview}
            className={styles.secondaryButton || styles.generateButton}
            disabled={participantesEmails.length === 0}
            type="button"
          >
            Pré-visualizar
          </button>
        )}
        <button
          onClick={gerarPDF}
          className={styles.generateButton}
          disabled={entrada.length === 0 || (consolidado && saida.length === 0)}
          type="button"
        >
          Baixar ZIP com PDFs
        </button>
      </div>

      {DEBUG && (
        <InlinePreview
          title={previewTitle}
          doc={previewDoc}
          onClose={() => setPreviewDoc(null)}
        />
      )}
    </div>
  );
};

export default PDFResumoCategorias;
